/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Address,
  ApiError,
  AutocompleteAddressResponse,
  ClearOverwolfCachesResponse,
  ConfigResponse,
  DeactivateElectronDataMappersResponse,
  DialCode,
  DuplicateOverwolfDataMappersResponse,
  EmitWebsocketBody,
  GenericCounter,
  GetFuelXOnchainTransactionResponse,
  GetGeography,
  GetLevelConfigsResponse,
  GetPlaceIdFromAddressResponse,
  LevelUpTable,
  MigrateOverwolfElectronQuestSourcesResponse,
  MongoConnectionInfo,
  PopulateOverwolfCachesTestResponse,
  RollbackOverwolfElectronDataMappersResponse,
  VersionResponse,
} from '../models/index';
import {
    AddressFromJSON,
    AddressToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    AutocompleteAddressResponseFromJSON,
    AutocompleteAddressResponseToJSON,
    ClearOverwolfCachesResponseFromJSON,
    ClearOverwolfCachesResponseToJSON,
    ConfigResponseFromJSON,
    ConfigResponseToJSON,
    DeactivateElectronDataMappersResponseFromJSON,
    DeactivateElectronDataMappersResponseToJSON,
    DialCodeFromJSON,
    DialCodeToJSON,
    DuplicateOverwolfDataMappersResponseFromJSON,
    DuplicateOverwolfDataMappersResponseToJSON,
    EmitWebsocketBodyFromJSON,
    EmitWebsocketBodyToJSON,
    GenericCounterFromJSON,
    GenericCounterToJSON,
    GetFuelXOnchainTransactionResponseFromJSON,
    GetFuelXOnchainTransactionResponseToJSON,
    GetGeographyFromJSON,
    GetGeographyToJSON,
    GetLevelConfigsResponseFromJSON,
    GetLevelConfigsResponseToJSON,
    GetPlaceIdFromAddressResponseFromJSON,
    GetPlaceIdFromAddressResponseToJSON,
    LevelUpTableFromJSON,
    LevelUpTableToJSON,
    MigrateOverwolfElectronQuestSourcesResponseFromJSON,
    MigrateOverwolfElectronQuestSourcesResponseToJSON,
    MongoConnectionInfoFromJSON,
    MongoConnectionInfoToJSON,
    PopulateOverwolfCachesTestResponseFromJSON,
    PopulateOverwolfCachesTestResponseToJSON,
    RollbackOverwolfElectronDataMappersResponseFromJSON,
    RollbackOverwolfElectronDataMappersResponseToJSON,
    VersionResponseFromJSON,
    VersionResponseToJSON,
} from '../models/index';

export interface CreateAddressToPlaceIdRequest {
    address?: Address;
}

export interface CreateEmitWebsocketRequest {
    emitWebsocketBody?: EmitWebsocketBody;
}

export interface GetAddressAutocompleteRequest {
    formattedAddress?: string;
}

export interface GetAddressAutocompletePostalCodeRequest {
    postalCode?: string;
}

export interface GetAddressFromLatLngRequest {
    latitude?: string;
    longitude?: string;
}

export interface GetAddressFromPlaceIdRequest {
    placeId?: string;
}

export interface GetUtilsGenericCounterRequest {
    key?: string;
}

export interface GetUtilsGetFuelxOnchainTransactionIdRequest {
    id: string;
}

export interface UpdateClearOverwolfCachesRequest {
    body?: object;
}

export interface UpdateInflateWalletTypesRequest {
    body?: object;
}

export interface UpdateMigrateDeactivateElectronDataMappersRequest {
    dryRun?: boolean;
    body?: object;
}

export interface UpdateMigrateDuplicateOverwolfDataMappersRequest {
    dryRun?: boolean;
    body?: object;
}

export interface UpdateMigrateOverwolfElectronQuestSourcesRequest {
    body?: object;
}

export interface UpdatePopulateOverwolfCachesTestRequest {
    body?: object;
}

export interface UpdateRollbackOverwolfElectronDataMappersRequest {
    dryRun?: boolean;
    body?: object;
}

/**
 * UtilsApi - interface
 * 
 * @export
 * @interface UtilsApiInterface
 */
export interface UtilsApiInterface {
    /**
     * Used to get place id from address body
     * @param {Address} [address] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    createAddressToPlaceIdRaw(requestParameters: CreateAddressToPlaceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPlaceIdFromAddressResponse>>;

    /**
     * Used to get place id from address body
     */
    createAddressToPlaceId(requestParameters: CreateAddressToPlaceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPlaceIdFromAddressResponse>;

    /**
     * Used to test websocket events.
     * @param {EmitWebsocketBody} [emitWebsocketBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    createEmitWebsocketRaw(requestParameters: CreateEmitWebsocketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to test websocket events.
     */
    createEmitWebsocket(requestParameters: CreateEmitWebsocketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to parse autocomplete from address
     * @param {string} [formattedAddress] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getAddressAutocompleteRaw(requestParameters: GetAddressAutocompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutocompleteAddressResponse>>;

    /**
     * Used to parse autocomplete from address
     */
    getAddressAutocomplete(requestParameters: GetAddressAutocompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutocompleteAddressResponse>;

    /**
     * Used to parse autocomplete from postal code
     * @param {string} [postalCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getAddressAutocompletePostalCodeRaw(requestParameters: GetAddressAutocompletePostalCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutocompleteAddressResponse>>;

    /**
     * Used to parse autocomplete from postal code
     */
    getAddressAutocompletePostalCode(requestParameters: GetAddressAutocompletePostalCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutocompleteAddressResponse>;

    /**
     * Used to get address body from place id
     * @param {string} [latitude] 
     * @param {string} [longitude] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getAddressFromLatLngRaw(requestParameters: GetAddressFromLatLngRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Address>>;

    /**
     * Used to get address body from place id
     */
    getAddressFromLatLng(requestParameters: GetAddressFromLatLngRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Address>;

    /**
     * Used to get address body from place id
     * @param {string} [placeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getAddressFromPlaceIdRaw(requestParameters: GetAddressFromPlaceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Address>>;

    /**
     * Used to get address body from place id
     */
    getAddressFromPlaceId(requestParameters: GetAddressFromPlaceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Address>;

    /**
     * Should always return a status code of 200. Used to determine if the server is up and working.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getHealthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Should always return a status code of 200. Used to determine if the server is up and working.
     */
    getHealth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * A safe public API to initialize the server. This API is sustainable to even if compromised, it will not cause problems.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getInitRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * A safe public API to initialize the server. This API is sustainable to even if compromised, it will not cause problems.
     */
    getInit(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Returns details about the current mongo connection through mongoose.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getMongoInformationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MongoConnectionInfo>>>;

    /**
     * Returns details about the current mongo connection through mongoose.
     */
    getMongoInformation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MongoConnectionInfo>>;

    /**
     * Used to get various configs for the system.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getUtilsConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigResponse>>;

    /**
     * Used to get various configs for the system.
     */
    getUtilsConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigResponse>;

    /**
     * Gets the model of a generic counter in the database.
     * @param {string} [key] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getUtilsGenericCounterRaw(requestParameters: GetUtilsGenericCounterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericCounter>>;

    /**
     * Gets the model of a generic counter in the database.
     */
    getUtilsGenericCounter(requestParameters: GetUtilsGenericCounterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericCounter>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getUtilsGetDialCodesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DialCode>>>;

    /**
     */
    getUtilsGetDialCodes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DialCode>>;

    /**
     * Look up the on-chain FuelX transaction for the given hash and return the recipient wallet address.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getUtilsGetFuelxOnchainTransactionIdRaw(requestParameters: GetUtilsGetFuelxOnchainTransactionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFuelXOnchainTransactionResponse>>;

    /**
     * Look up the on-chain FuelX transaction for the given hash and return the recipient wallet address.
     */
    getUtilsGetFuelxOnchainTransactionId(requestParameters: GetUtilsGetFuelxOnchainTransactionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFuelXOnchainTransactionResponse>;

    /**
     * Used to get a list of all countries and their phone dial codes. Also includes Canadian provinces and USA states.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getUtilsGetGeographyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGeography>>;

    /**
     * Used to get a list of all countries and their phone dial codes. Also includes Canadian provinces and USA states.
     */
    getUtilsGetGeography(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGeography>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getUtilsGetTimeZonesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>>;

    /**
     */
    getUtilsGetTimeZones(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>>;

    /**
     * Returns all active level configs (cached, public).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getUtilsLevelConfigsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLevelConfigsResponse>>;

    /**
     * Returns all active level configs (cached, public).
     */
    getUtilsLevelConfigs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLevelConfigsResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getUtilsLevelUpTableRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LevelUpTable>>;

    /**
     */
    getUtilsLevelUpTable(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LevelUpTable>;

    /**
     * Finds what version of the app you are using
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    getVersionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VersionResponse>>;

    /**
     * Finds what version of the app you are using
     */
    getVersion(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VersionResponse>;

    /**
     * Clears all OVERWOLF and OVERWOLF_ELECTRON related caches: - Raw data mapper caches for all games and both sources - All quest config caches 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    updateClearOverwolfCachesRaw(requestParameters: UpdateClearOverwolfCachesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClearOverwolfCachesResponse>>;

    /**
     * Clears all OVERWOLF and OVERWOLF_ELECTRON related caches: - Raw data mapper caches for all games and both sources - All quest config caches 
     */
    updateClearOverwolfCaches(requestParameters: UpdateClearOverwolfCachesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClearOverwolfCachesResponse>;

    /**
     * Inflate the \"type\" field for old documents.
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    updateInflateWalletTypesRaw(requestParameters: UpdateInflateWalletTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Inflate the \"type\" field for old documents.
     */
    updateInflateWalletTypes(requestParameters: UpdateInflateWalletTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Migration endpoint that deactivates any data mappers with \'electron\' in the name (case insensitive). Use dryRun=true to preview what would be deactivated without making changes. 
     * @param {boolean} [dryRun] If true, returns what would be deactivated without making changes
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    updateMigrateDeactivateElectronDataMappersRaw(requestParameters: UpdateMigrateDeactivateElectronDataMappersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeactivateElectronDataMappersResponse>>;

    /**
     * Migration endpoint that deactivates any data mappers with \'electron\' in the name (case insensitive). Use dryRun=true to preview what would be deactivated without making changes. 
     */
    updateMigrateDeactivateElectronDataMappers(requestParameters: UpdateMigrateDeactivateElectronDataMappersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeactivateElectronDataMappersResponse>;

    /**
     * Migration endpoint that duplicates all active OVERWOLF data mappers to OVERWOLF_ELECTRON source. Excludes mappers with \'electron\' in the name. Use dryRun=true to preview what would be duplicated without making changes. 
     * @param {boolean} [dryRun] If true, returns what would be duplicated without making changes
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    updateMigrateDuplicateOverwolfDataMappersRaw(requestParameters: UpdateMigrateDuplicateOverwolfDataMappersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DuplicateOverwolfDataMappersResponse>>;

    /**
     * Migration endpoint that duplicates all active OVERWOLF data mappers to OVERWOLF_ELECTRON source. Excludes mappers with \'electron\' in the name. Use dryRun=true to preview what would be duplicated without making changes. 
     */
    updateMigrateDuplicateOverwolfDataMappers(requestParameters: UpdateMigrateDuplicateOverwolfDataMappersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DuplicateOverwolfDataMappersResponse>;

    /**
     * Migration endpoint that updates quest configs to add OVERWOLF_ELECTRON to milestone sources. For any milestone that has OVERWOLF in its sources array, adds OVERWOLF_ELECTRON if not already present. 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    updateMigrateOverwolfElectronQuestSourcesRaw(requestParameters: UpdateMigrateOverwolfElectronQuestSourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MigrateOverwolfElectronQuestSourcesResponse>>;

    /**
     * Migration endpoint that updates quest configs to add OVERWOLF_ELECTRON to milestone sources. For any milestone that has OVERWOLF in its sources array, adds OVERWOLF_ELECTRON if not already present. 
     */
    updateMigrateOverwolfElectronQuestSources(requestParameters: UpdateMigrateOverwolfElectronQuestSourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MigrateOverwolfElectronQuestSourcesResponse>;

    /**
     * Populates raw data mapper and quest config caches with fake test data for OVERWOLF and OVERWOLF_ELECTRON. Covers all key formats (with/without gameId). Use this to test that cache clearing functions work correctly. 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    updatePopulateOverwolfCachesTestRaw(requestParameters: UpdatePopulateOverwolfCachesTestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PopulateOverwolfCachesTestResponse>>;

    /**
     * Populates raw data mapper and quest config caches with fake test data for OVERWOLF and OVERWOLF_ELECTRON. Covers all key formats (with/without gameId). Use this to test that cache clearing functions work correctly. 
     */
    updatePopulateOverwolfCachesTest(requestParameters: UpdatePopulateOverwolfCachesTestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PopulateOverwolfCachesTestResponse>;

    /**
     * Rollback endpoint that undoes the OVERWOLF_ELECTRON migration by deactivating all OVERWOLF_ELECTRON data mappers. Use dryRun=true to preview what would be changed without making changes. 
     * @param {boolean} [dryRun] If true, returns what would be changed without making changes
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApiInterface
     */
    updateRollbackOverwolfElectronDataMappersRaw(requestParameters: UpdateRollbackOverwolfElectronDataMappersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RollbackOverwolfElectronDataMappersResponse>>;

    /**
     * Rollback endpoint that undoes the OVERWOLF_ELECTRON migration by deactivating all OVERWOLF_ELECTRON data mappers. Use dryRun=true to preview what would be changed without making changes. 
     */
    updateRollbackOverwolfElectronDataMappers(requestParameters: UpdateRollbackOverwolfElectronDataMappersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RollbackOverwolfElectronDataMappersResponse>;

}

/**
 * 
 */
export class UtilsApi extends runtime.BaseAPI implements UtilsApiInterface {

    /**
     * Used to get place id from address body
     */
    async createAddressToPlaceIdRaw(requestParameters: CreateAddressToPlaceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPlaceIdFromAddressResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/address/to-place-id`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddressToJSON(requestParameters['address']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPlaceIdFromAddressResponseFromJSON(jsonValue));
    }

    /**
     * Used to get place id from address body
     */
    async createAddressToPlaceId(requestParameters: CreateAddressToPlaceIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPlaceIdFromAddressResponse> {
        const response = await this.createAddressToPlaceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to test websocket events.
     */
    async createEmitWebsocketRaw(requestParameters: CreateEmitWebsocketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/emit-websocket`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmitWebsocketBodyToJSON(requestParameters['emitWebsocketBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to test websocket events.
     */
    async createEmitWebsocket(requestParameters: CreateEmitWebsocketRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createEmitWebsocketRaw(requestParameters, initOverrides);
    }

    /**
     * Used to parse autocomplete from address
     */
    async getAddressAutocompleteRaw(requestParameters: GetAddressAutocompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutocompleteAddressResponse>> {
        const queryParameters: any = {};

        if (requestParameters['formattedAddress'] != null) {
            queryParameters['formattedAddress'] = requestParameters['formattedAddress'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/address/autocomplete`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AutocompleteAddressResponseFromJSON(jsonValue));
    }

    /**
     * Used to parse autocomplete from address
     */
    async getAddressAutocomplete(requestParameters: GetAddressAutocompleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutocompleteAddressResponse> {
        const response = await this.getAddressAutocompleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to parse autocomplete from postal code
     */
    async getAddressAutocompletePostalCodeRaw(requestParameters: GetAddressAutocompletePostalCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutocompleteAddressResponse>> {
        const queryParameters: any = {};

        if (requestParameters['postalCode'] != null) {
            queryParameters['postalCode'] = requestParameters['postalCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/address/autocomplete/postal-code`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AutocompleteAddressResponseFromJSON(jsonValue));
    }

    /**
     * Used to parse autocomplete from postal code
     */
    async getAddressAutocompletePostalCode(requestParameters: GetAddressAutocompletePostalCodeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutocompleteAddressResponse> {
        const response = await this.getAddressAutocompletePostalCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get address body from place id
     */
    async getAddressFromLatLngRaw(requestParameters: GetAddressFromLatLngRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Address>> {
        const queryParameters: any = {};

        if (requestParameters['latitude'] != null) {
            queryParameters['latitude'] = requestParameters['latitude'];
        }

        if (requestParameters['longitude'] != null) {
            queryParameters['longitude'] = requestParameters['longitude'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/address/from-lat-lng`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddressFromJSON(jsonValue));
    }

    /**
     * Used to get address body from place id
     */
    async getAddressFromLatLng(requestParameters: GetAddressFromLatLngRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Address> {
        const response = await this.getAddressFromLatLngRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get address body from place id
     */
    async getAddressFromPlaceIdRaw(requestParameters: GetAddressFromPlaceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Address>> {
        const queryParameters: any = {};

        if (requestParameters['placeId'] != null) {
            queryParameters['placeId'] = requestParameters['placeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/address/from-place-id`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddressFromJSON(jsonValue));
    }

    /**
     * Used to get address body from place id
     */
    async getAddressFromPlaceId(requestParameters: GetAddressFromPlaceIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Address> {
        const response = await this.getAddressFromPlaceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Should always return a status code of 200. Used to determine if the server is up and working.
     */
    async getHealthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/health`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Should always return a status code of 200. Used to determine if the server is up and working.
     */
    async getHealth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getHealthRaw(initOverrides);
    }

    /**
     * A safe public API to initialize the server. This API is sustainable to even if compromised, it will not cause problems.
     */
    async getInitRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/init`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * A safe public API to initialize the server. This API is sustainable to even if compromised, it will not cause problems.
     */
    async getInit(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getInitRaw(initOverrides);
    }

    /**
     * Returns details about the current mongo connection through mongoose.
     */
    async getMongoInformationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MongoConnectionInfo>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/mongo_information`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MongoConnectionInfoFromJSON));
    }

    /**
     * Returns details about the current mongo connection through mongoose.
     */
    async getMongoInformation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MongoConnectionInfo>> {
        const response = await this.getMongoInformationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Used to get various configs for the system.
     */
    async getUtilsConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/utils/config`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigResponseFromJSON(jsonValue));
    }

    /**
     * Used to get various configs for the system.
     */
    async getUtilsConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigResponse> {
        const response = await this.getUtilsConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets the model of a generic counter in the database.
     */
    async getUtilsGenericCounterRaw(requestParameters: GetUtilsGenericCounterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericCounter>> {
        const queryParameters: any = {};

        if (requestParameters['key'] != null) {
            queryParameters['key'] = requestParameters['key'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/utils/generic-counter`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenericCounterFromJSON(jsonValue));
    }

    /**
     * Gets the model of a generic counter in the database.
     */
    async getUtilsGenericCounter(requestParameters: GetUtilsGenericCounterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericCounter> {
        const response = await this.getUtilsGenericCounterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUtilsGetDialCodesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DialCode>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/utils/get-dial-codes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DialCodeFromJSON));
    }

    /**
     */
    async getUtilsGetDialCodes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DialCode>> {
        const response = await this.getUtilsGetDialCodesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Look up the on-chain FuelX transaction for the given hash and return the recipient wallet address.
     */
    async getUtilsGetFuelxOnchainTransactionIdRaw(requestParameters: GetUtilsGetFuelxOnchainTransactionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFuelXOnchainTransactionResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUtilsGetFuelxOnchainTransactionId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/utils/get-fuelx-onchain-transaction/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFuelXOnchainTransactionResponseFromJSON(jsonValue));
    }

    /**
     * Look up the on-chain FuelX transaction for the given hash and return the recipient wallet address.
     */
    async getUtilsGetFuelxOnchainTransactionId(requestParameters: GetUtilsGetFuelxOnchainTransactionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFuelXOnchainTransactionResponse> {
        const response = await this.getUtilsGetFuelxOnchainTransactionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get a list of all countries and their phone dial codes. Also includes Canadian provinces and USA states.
     */
    async getUtilsGetGeographyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGeography>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/utils/get-geography`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGeographyFromJSON(jsonValue));
    }

    /**
     * Used to get a list of all countries and their phone dial codes. Also includes Canadian provinces and USA states.
     */
    async getUtilsGetGeography(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGeography> {
        const response = await this.getUtilsGetGeographyRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getUtilsGetTimeZonesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/utils/get-time-zones`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getUtilsGetTimeZones(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getUtilsGetTimeZonesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns all active level configs (cached, public).
     */
    async getUtilsLevelConfigsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLevelConfigsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/utils/level-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLevelConfigsResponseFromJSON(jsonValue));
    }

    /**
     * Returns all active level configs (cached, public).
     */
    async getUtilsLevelConfigs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLevelConfigsResponse> {
        const response = await this.getUtilsLevelConfigsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getUtilsLevelUpTableRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LevelUpTable>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/utils/level-up-table`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LevelUpTableFromJSON(jsonValue));
    }

    /**
     */
    async getUtilsLevelUpTable(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LevelUpTable> {
        const response = await this.getUtilsLevelUpTableRaw(initOverrides);
        return await response.value();
    }

    /**
     * Finds what version of the app you are using
     */
    async getVersionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VersionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/version`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VersionResponseFromJSON(jsonValue));
    }

    /**
     * Finds what version of the app you are using
     */
    async getVersion(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VersionResponse> {
        const response = await this.getVersionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Clears all OVERWOLF and OVERWOLF_ELECTRON related caches: - Raw data mapper caches for all games and both sources - All quest config caches 
     */
    async updateClearOverwolfCachesRaw(requestParameters: UpdateClearOverwolfCachesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClearOverwolfCachesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/clear-overwolf-caches`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClearOverwolfCachesResponseFromJSON(jsonValue));
    }

    /**
     * Clears all OVERWOLF and OVERWOLF_ELECTRON related caches: - Raw data mapper caches for all games and both sources - All quest config caches 
     */
    async updateClearOverwolfCaches(requestParameters: UpdateClearOverwolfCachesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClearOverwolfCachesResponse> {
        const response = await this.updateClearOverwolfCachesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Inflate the \"type\" field for old documents.
     */
    async updateInflateWalletTypesRaw(requestParameters: UpdateInflateWalletTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("GodAdmin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/inflate-wallet-types`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Inflate the \"type\" field for old documents.
     */
    async updateInflateWalletTypes(requestParameters: UpdateInflateWalletTypesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateInflateWalletTypesRaw(requestParameters, initOverrides);
    }

    /**
     * Migration endpoint that deactivates any data mappers with \'electron\' in the name (case insensitive). Use dryRun=true to preview what would be deactivated without making changes. 
     */
    async updateMigrateDeactivateElectronDataMappersRaw(requestParameters: UpdateMigrateDeactivateElectronDataMappersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeactivateElectronDataMappersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['dryRun'] != null) {
            queryParameters['dryRun'] = requestParameters['dryRun'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/migrate-deactivate-electron-data-mappers`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeactivateElectronDataMappersResponseFromJSON(jsonValue));
    }

    /**
     * Migration endpoint that deactivates any data mappers with \'electron\' in the name (case insensitive). Use dryRun=true to preview what would be deactivated without making changes. 
     */
    async updateMigrateDeactivateElectronDataMappers(requestParameters: UpdateMigrateDeactivateElectronDataMappersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeactivateElectronDataMappersResponse> {
        const response = await this.updateMigrateDeactivateElectronDataMappersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Migration endpoint that duplicates all active OVERWOLF data mappers to OVERWOLF_ELECTRON source. Excludes mappers with \'electron\' in the name. Use dryRun=true to preview what would be duplicated without making changes. 
     */
    async updateMigrateDuplicateOverwolfDataMappersRaw(requestParameters: UpdateMigrateDuplicateOverwolfDataMappersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DuplicateOverwolfDataMappersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['dryRun'] != null) {
            queryParameters['dryRun'] = requestParameters['dryRun'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/migrate-duplicate-overwolf-data-mappers`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DuplicateOverwolfDataMappersResponseFromJSON(jsonValue));
    }

    /**
     * Migration endpoint that duplicates all active OVERWOLF data mappers to OVERWOLF_ELECTRON source. Excludes mappers with \'electron\' in the name. Use dryRun=true to preview what would be duplicated without making changes. 
     */
    async updateMigrateDuplicateOverwolfDataMappers(requestParameters: UpdateMigrateDuplicateOverwolfDataMappersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DuplicateOverwolfDataMappersResponse> {
        const response = await this.updateMigrateDuplicateOverwolfDataMappersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Migration endpoint that updates quest configs to add OVERWOLF_ELECTRON to milestone sources. For any milestone that has OVERWOLF in its sources array, adds OVERWOLF_ELECTRON if not already present. 
     */
    async updateMigrateOverwolfElectronQuestSourcesRaw(requestParameters: UpdateMigrateOverwolfElectronQuestSourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MigrateOverwolfElectronQuestSourcesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/migrate-overwolf-electron-quest-sources`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MigrateOverwolfElectronQuestSourcesResponseFromJSON(jsonValue));
    }

    /**
     * Migration endpoint that updates quest configs to add OVERWOLF_ELECTRON to milestone sources. For any milestone that has OVERWOLF in its sources array, adds OVERWOLF_ELECTRON if not already present. 
     */
    async updateMigrateOverwolfElectronQuestSources(requestParameters: UpdateMigrateOverwolfElectronQuestSourcesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MigrateOverwolfElectronQuestSourcesResponse> {
        const response = await this.updateMigrateOverwolfElectronQuestSourcesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Populates raw data mapper and quest config caches with fake test data for OVERWOLF and OVERWOLF_ELECTRON. Covers all key formats (with/without gameId). Use this to test that cache clearing functions work correctly. 
     */
    async updatePopulateOverwolfCachesTestRaw(requestParameters: UpdatePopulateOverwolfCachesTestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PopulateOverwolfCachesTestResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/populate-overwolf-caches-test`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PopulateOverwolfCachesTestResponseFromJSON(jsonValue));
    }

    /**
     * Populates raw data mapper and quest config caches with fake test data for OVERWOLF and OVERWOLF_ELECTRON. Covers all key formats (with/without gameId). Use this to test that cache clearing functions work correctly. 
     */
    async updatePopulateOverwolfCachesTest(requestParameters: UpdatePopulateOverwolfCachesTestRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PopulateOverwolfCachesTestResponse> {
        const response = await this.updatePopulateOverwolfCachesTestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rollback endpoint that undoes the OVERWOLF_ELECTRON migration by deactivating all OVERWOLF_ELECTRON data mappers. Use dryRun=true to preview what would be changed without making changes. 
     */
    async updateRollbackOverwolfElectronDataMappersRaw(requestParameters: UpdateRollbackOverwolfElectronDataMappersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RollbackOverwolfElectronDataMappersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['dryRun'] != null) {
            queryParameters['dryRun'] = requestParameters['dryRun'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/rollback-overwolf-electron-data-mappers`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RollbackOverwolfElectronDataMappersResponseFromJSON(jsonValue));
    }

    /**
     * Rollback endpoint that undoes the OVERWOLF_ELECTRON migration by deactivating all OVERWOLF_ELECTRON data mappers. Use dryRun=true to preview what would be changed without making changes. 
     */
    async updateRollbackOverwolfElectronDataMappers(requestParameters: UpdateRollbackOverwolfElectronDataMappersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RollbackOverwolfElectronDataMappersResponse> {
        const response = await this.updateRollbackOverwolfElectronDataMappersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
